import { render, staticRenderFns } from "./bidClarification.vue?vue&type=template&id=feb818e6&scoped=true"
import script from "./bidClarification.vue?vue&type=script&lang=js"
export * from "./bidClarification.vue?vue&type=script&lang=js"
import style0 from "./bidClarification.vue?vue&type=style&index=0&id=feb818e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb818e6",
  null
  
)

export default component.exports